module.exports = __webpack_public_path__ + "static/media/nav_menu_teachers.e24f674d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./img/svg/nav_menu_teachers.svg
 ** module id = 297
 ** module chunks = 0
 **/